<!-- Top bar -->
<mat-toolbar class="topBar" style="justify-content: space-between;">
  <button mat-mini-fab
          class="icon-button"
          aria-label="Back to Menu"
          matTooltip="Back to Menu"
          matTooltipPosition="above"
          (click)="router.navigate(['menu'], { queryParams: { fishery: fishery === 'Trawl' ? 2 : 0 } })">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span style="flex-grow: 1; padding-left: 12px;">
    Summary - Observer View
  </span>
</mat-toolbar>


<!-- Non-Trawl (Groundfish) view -->
@if (fishery !== 'Trawl') {
  <div class="sets-container">

    @for (set of groundfishSets(); track set.fishingEventID) {
      <mat-card class="set-card">
        <mat-card-header>
          <mat-card-title>Set {{ set.setNumber || '—' }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="set-field"><b>Set:</b> {{ set.startDate | date:'MMM d, y, HH:mm' }}</div>
          @if (set.gear?.type !== 'Pelagic') {
            <div class="set-field"><b>Set Depth:</b> {{ (set.startDepth | isDefined) ? set.startDepth : '-' }}</div>
          }
          <div class="set-field"><b>Retrieval:</b> {{ set.endDate | date:'MMM d, y, HH:mm' }}</div>
          @if (set.gear?.type !== 'Pelagic') {
            <div class="set-field"><b>Retrieval Depth:</b> {{ (set.endDepth | isDefined) ? set.endDepth : '-' }}</div>
          }
          @if (set.gear?.type === 'Pelagic') {
            <div class="set-field"><b>Depth off Bottom:</b> {{ (set.depthOffBottom | isDefined) ? set.depthOffBottom : '-' }}</div>
          }
          @if (set.gear?.type !== 'Pelagic') {
            <div class="set-field"><b>Gear Set:</b> {{ (set.skateNum | isDefined) ? set.skateNum : '-' }}</div>
          }
          @if (set.gear?.type !== 'Pelagic') {
            <div class="set-field"><b>Gear Lost:</b> {{ (set.lostPotCount | isDefined) ? set.lostPotCount : 0 }}</div>
          }
          <div class="set-field"><b>Comments:</b> {{ set.comments || '-' }}</div>

          @if (set.catchItems && set.catchItems.length > 0) {
            <table class="catch-table">
              <thead>
                <tr>
                  <th class="species-col" style="font-weight: bold;">Species</th>
                  <th class="weight-col" style="font-weight: bold;">Retained Weight</th>
                </tr>
              </thead>
              <tbody>
                @for (catch of set.catchItems; let i = $index; track i) {
                  <tr>
                    <td class="species-col">{{ catch.species.name }}</td>
                    <td class="weight-col">{{ catch.retainedWeight ?? '-' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (groundfishSets().length === 0) {
      <div class="empty-message">
        <h3>No sets recorded.</h3>
      </div>
    }

  </div>
}


<!-- Trawl view -->
@if (fishery === 'Trawl') {
  <div class="sets-container">

    @for (set of trawlSets(); track set.fishingEventID) {
      <mat-card class="set-card">
        <mat-card-content>
          <div class="set-field"><b>Set:</b> {{ set.startDate | date:'MMM d, y, HH:mm' }}</div>
          <div class="set-field"><b>Retrieval:</b> {{ set.endDate | date:'MMM d, y, HH:mm' }}</div>
          <div class="set-field"><b>Target:</b> {{ set.targetSpecies?.name || '-' }}</div>
          <div class="set-field"><b>Depth:</b> {{ set.averageDepth ?? '-' }}</div>
          <div class="set-field"><b>Comments:</b> {{ set.comments || '-' }}</div>

          @if (set.catchItems && set.catchItems.length > 0) {
            <table class="catch-table">
              <thead>
                <tr>
                  <th class="species-col" style="font-weight: bold;">Species</th>
                  <th class="weight-col" style="font-weight: bold;">Retained Weight</th>
                </tr>
              </thead>
              <tbody>
                @for (catch of set.catchItems; let i = $index; track i) {
                  <tr>
                    <td class="species-col">{{ catch.species.name }}</td>
                    <td class="weight-col">{{ catch.retainedWeight ?? '-' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (trawlSets().length === 0) {
      <div class="empty-message">
        <h3>No hauls recorded.</h3>
      </div>
    }

  </div>
}
